import React, { useState } from 'react'
import ContributionFilter from './ContributionsFilter'
import { Table, Button, Row, Col } from 'antd'
import { ContributionsSummaryReportApi } from '../../services/apiService'
import { showApiError, renderFooterTable } from '../utilities'
import { CSVLink } from 'react-csv'
import "moment/locale/en-nz"
import moment from "moment"
import CreateAndSavePDF from './GenContSummaryPDF'

function SummaryReport(props) {
  const [data, setData] = useState([])
  const [readyPDF, setReadyPDF] = useState(false)
  const [groupBy, setGroupBy] = useState(1)
  const [search, setSearch] = useState({ fromDate: moment().day(0), toDate: moment(), contId:0})
  //console.log("fromDate at then top :" + search.fromDate.toString())

  function handleSearch(filter) {
    let querystring = `?from=${filter.fromDate}&to=${filter.toDate}&contId=${filter.contId}&groupby=${filter.groupBy}`
    //console.log(`${querystring}`)
    setGroupBy(parseInt(filter.groupBy))
    LoadData(querystring)
    setSearch({ fromDate: moment(filter.fromDate), toDate: moment(filter.toDate), contId:filter.contId, selectedMember: filter.selectedMember, offeringNo: filter.offeringNo }  )
  }

  let columns = [
    {
      title: groupBy ? 'Fund' : 'Contribution Date',
      dataIndex: 'groupKey',
      key: 'groupKey',
    },
    {
      title: 'Total',
      dataIndex: 'total',
      align: 'right',
      render: (item, row) => <span>{item.toFixed(2)}</span>
    },

  ]

  function LoadData(querystring) {
    ContributionsSummaryReportApi(querystring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          setData(json)
        }
      })
      .catch(error => {
        showApiError(error);
      });

  }


  function FinishDownloadPDF() {
    setReadyPDF(false)
  }

  function ShowTable() {
    if (data.length > 0) {
      return (
        <Row >
          <Col sm={24} md={ 12}>
          <div className='buttonsbar'>
            <CSVLink data={data} filename='contribution_summary.csv' >
              <Button icon='file-excel'>Download CSV</Button> </CSVLink>
            <Button icon='file-pdf' onClick={() => setReadyPDF(true)} >Download PDF</Button>
            <CreateAndSavePDF data={data} ready={readyPDF} doFinish={FinishDownloadPDF}
              { ...search }  />
            {/*<PDFDownloadLink document={<GetPDF data={data} />} fileName="tax-cert.pdf">
              <Button icon='file-pdf'>Download PDF</Button> </PDFDownloadLink> */}
          </div>
          <div className="center" >
            <Table dataSource={data} columns={columns}
              rowKey="groupKey" pagination={false}
              size={size} />
            {renderFooterTable(total, columns, 'groupKey', size)}
          </div>
          </Col>
        </Row>)
    }

    return null

  }

  let total = data.reduce((total, item) => total + item.total, 0)
  let size = "middle"
  return (
    <div className="content">
      <h2>{props.title}</h2>
      <div>
        <ContributionFilter fromDate={search.fromDate} toDate={search.toDate} doSearch={handleSearch}
          groupBy={groupBy} />
        <ShowTable />
      </div>
    </div>
  )

}

export default SummaryReport;